import { CargoTemperatureBM } from '../types/BusinessModel/CargoTemperatureBM';

import { CargoTemperature } from '../types/ViewModel/CargoTemperature';

export class CargoTemperatureFactory {
    public create(data: CargoTemperatureBM): CargoTemperature {
        return new CargoTemperature(
            data.cargoNumber,
            data.commodityId,
            data.isOnBoard,
            data.isNotRequiringHeating,
            data.temperature,
            data.cargoLoadingTemperature
        );
    }

    public createList(data: CargoTemperatureBM[]): CargoTemperature[] {
        return data.map((h) => this.create(h));
    }
}
